import React, { useContext } from "react";

import { HandlerContext } from "../../../../../lnb/LnbWrapper";

function ListItem({ titleText, contentText, dateText, link }) {
    const handlerContext = useContext(HandlerContext);

    const handleClickListItem = () => {
        // TODO: 링크 제거 하드코딩 제거
        handlerContext.clickMenuTypeCodeLINK(link);
    };

    return (
        <div className="clear infortxtbox2" onClick={handleClickListItem}>
            <div className="fl infortxt5">{titleText}</div>
            <div className="fl infortxt6">{contentText}</div>
            <div className="fr infortxt2">{dateText}</div>
        </div>
    );
}

export default ListItem;
